import {  ComponentRef, ElementRef, HostListener,Input,ViewChild} from '@angular/core';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { CorrespondantPatient } from 'src/app/utils/interfaces/new/correspondant-patient';
import { PatientService } from 'src/app/services/patient/patient.service';
import { CourriersService } from 'src/app/services/consultation/courriers/courriers.service';
import { CorrespondantCourrier } from 'src/app/utils/interfaces/new/correspondant-courrier.interface';
import { Correspondant, CorrespondantExtended } from 'src/app/utils/interfaces/new/correspondant.interface';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { environment } from 'src/environments/environment';
import { Component, OnInit, ViewContainerRef,Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, ValidationErrors, AbstractControl, FormControl } from '@angular/forms';
import { AnnuaireProfessionnelsSanteService } from 'src/app/services/annuaire-professionnels-sante/annuaire-professionnels-sante.service';
import { CorrespondantService } from 'src/app/services/correspondant/correspondant.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { PractitionerSearchParams } from 'src/app/services/mss/mss-service.abstract';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { AnnuaireResultCorrespondant } from 'src/app/utils/interfaces/new/annuaire-result-correspondant.interface';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { Practitioner } from 'src/app/utils/interfaces/new/Practitioner';
import { PractitionerSearchResult } from 'src/app/utils/interfaces/new/PractitionerSearchResult';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';
import { MssServiceFactory } from 'src/app/services/mss/mss-service.factory';
import { PractitionerSearchResultApi } from 'src/app/utils/interfaces/new/PractitionerSearchResultApi';
import { MedecinSpecialities, PharmacienSpecialities, ChirDentisteSpecialities } from '../../../services/cpx-handle/cpx-handle-utils.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { Repertoire } from 'src/app/utils/interfaces/new/repertoire';
import { LoadingModalFragment } from '../loading/loading-modal.fragment';
import { MatTableDataSource } from '@angular/material/table';


const PROFESSION_OID = '1.2.250.1.71.1.2.7';
const SPECIALITE_OID = '1.2.250.1.71.4.2.5';

export function atLeastOneFieldValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const hasValue = Object.values(group.value).some(value => {
      return typeof value === 'string'
        ? value.trim() !== ''
        : value !== null && value !== undefined;
    });

    return hasValue ? null : { atLeastOne: true };
  };
}


@Component({
  selector: 'app-add-correspondant-courrier',
  templateUrl: './add-correspondant-courrier.fragment.html',
  styleUrls: [
    './add-correspondant-courrier.fragment.scss',
    '../modal.fragment.scss',
  ],
})
export class AddCorrespondantCourrier implements OnInit {
  @ViewChild('modalBodyCor') public modalBody: ElementRef;
  @ViewChild('outsideModalCor') public outsideModal: ElementRef;

  public modalTitle: string = 'Ajout de correspondants au courrier';
  public specialites: Array<{id: string, libelle: string}> = [];
  public idCourrier: string;
  public idPatient: string;
  public isApicryptAccount: boolean;
  public option: string;

  public noApicryptMessage: string = '';

  @Output() public correspondantsUpdated = new EventEmitter<Correspondant[]>();
  @Output() correspondantsSelected = new EventEmitter<Correspondant[]>();

  @Output() public closeEmitter = new EventEmitter();
  @Input() public selectBodyTablePatient: Paginated<Correspondant> = {
    objects: [],
    page: 1,
    perpage: -1,
    total: 0,
  };
  public searchDone = false;
  public dataSource: MatTableDataSource<Correspondant>;
  public dataSourceCabinet: MatTableDataSource<Correspondant>;
  public displayedColumns: Array<string> = ['correspondantName', 'adresseMail'];
  public displayedColumnsCabinet: Array<string> = [
    'correspondantName',
    'adresseMail',
  ];

  public displayCorrespondant: boolean = false;

  public refSpecialite: Referentiel[];
  public refProfession: Referentiel[];
  public correspondantsFiltred: AnnuaireResultCorrespondant[];
  public correspondantInfos: AnnuaireResultCorrespondant;
  public specialiteName: string;

  public searchCorrespondantForm: FormGroup;
  public selectedTabIndex = 0; // 0 = Correspondant, 1 = Annuaire (apicrypt ou mss)
  public formGroup: FormGroup;
  public isSearching: boolean = false;
  public result: PractitionerSearchResult;
  public resultApi: PractitionerSearchResultApi;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (
      !this.modalBody.nativeElement.contains(event.target) &&
      this.outsideModal.nativeElement.contains(event.target)
    ) {
      this.closeAddEditModal();
    }
  }

  selectBodyTable: Paginated<CorrespondantCourrier> = {
    objects: [],
    page: 1,
    perpage: -1,
    total: 0,
  };

  selectColumnTable = [
    { title: 'Sélection courrier', data: 'nom' },
    { title: 'Supprimer', data: null },
  ];

  untouchedCorrespondants: Correspondant[];

  public finalSelectedCorrespondants: CorrespondantExtended[] = [];
  public correspondantsArray: CorrespondantExtended[] = [];

  correspondantsCabinet: Correspondant[];
  correspondantsPatient: Correspondant[];
  untouchedCorrespondantsPatient: CorrespondantPatient[];
  untouchedContacts: Repertoire[];
  correspondantCtrl = new FormControl('');

  constructor(
    private _patient: PatientService,
    private _courrier: CourriersService,
    private _correspondant: CorrespondantService,
    private _strUtilsSrv: StringUtilsService,
    private _builder: FormBuilder,
    public _ref: ReferentielService,
    private _view: ViewContainerRef,
    private _modal: ModalService,
    private _send: HeaderCommunicationService,
    private _annuaireProSrv: AnnuaireProfessionnelsSanteService,
    private _mssSrv: MssServiceFactory,
    private _snack: SnackbarService
  ) {
    const head: Header = {
      isBack: true,
      title: 'Recherche annuaire externe des correspondants',
      backPage: 'correspondant',
    };
    this._send.announceHeader(head);
  }

  async ngOnInit(): Promise<void> {
    const load = this._modal.openLoading(this._view);
    try {
      this.refSpecialite = await (
        await this._ref.findRefListTableHypermed(
          ReferentielEnum.subjectrole_dmp
        )
      ).map((qualite) => {
        return { id: qualite.id, libelle: qualite.libelle };
      });
      this.refProfession = await (
        await this._ref.findRefListTableHypermed(
          ReferentielEnum.subjectrole_dmp
        )
      ).map((qualite) => {
        return { id: qualite.id, libelle: qualite.libelle };
      });

      this.searchCorrespondantForm = this._builder.group(
        {
          speciality: [],
          nom: [],
          codePostal: [],
          ville: [],
        },
        { validators: atLeastOneFieldValidator() }
      );

      this.formGroup = this._builder.group(
        {
          exerciceName: [''],
          firstName: [''],
          professionSpeciality: [''],
          profession: [''],
          speciality: [''],
          rpps: [''],
          structureOrAddress: [''],
          email: [''],
          zip: [''],
          city: [''],
        },
        { validators: atLeastOneFieldValidator() }
      );

      this.specialites = [
        { id: '', libelle: 'Toutes les spécialités' },
        ...MedecinSpecialities.map(s => ({ id: s.code, libelle: s.libelle })),
        ...PharmacienSpecialities.map(s => ({ id: s.code, libelle: s.libelle })),
        ...ChirDentisteSpecialities.map(s => ({ id: s.code, libelle: s.libelle }))
      ].sort((a, b) => a.id === '' ? -1 : (b.id === '' ? 1 : a.libelle.localeCompare(b.libelle)));

      this.initCorrespPatient();
      this.addCorrespondantAlreadySelected();
    } catch (error) {
      console.warn(error);
    } finally {
      this._modal.close(load);
    }
  }

  public addCorrespondantAlreadySelected() {
    this.finalSelectedCorrespondants = this.correspondantsArray;
  }

  getTableTitle(option: string){
    if(this.isApicryptAccount){
      return `Correspondants du ${option} ayant une adresse MSS ou Apicrypt`
    }
    return `Correspondants du ${option} ayant une adresse MSS (ou interop apicrypt)`
  }
  // Donne l'adresse mail du correspondant au survol du mat-chip de son nom
  getChipTitle(correspondant: any): string {
    if (correspondant.isAlreadyAdded) {
      return correspondant.email;
    }
    return correspondant.isApicryptSelected
      ? correspondant.adresseApiCrypt
      : correspondant.email2;
  }


  closeAddEditModal() {
    this.closeEmitter.emit();
    this.finalSelectedCorrespondants = [];
  }

  public validateCorrespondants(): void {
    let email: string;
    const selectedCorrespondants = this.finalSelectedCorrespondants.map(
      (correspondant) => {
        if(correspondant.isAlreadyAdded){
      email= correspondant.email
    }else{
      email = correspondant.adresseApiCrypt && correspondant.isApicryptSelected
              ? correspondant.adresseApiCrypt
              : correspondant.email2
    }
        return {
          nom: correspondant.nom ? correspondant.nom : '',
          prenom: correspondant.prenom ? correspondant.prenom : '',
          email: email,
          isAlreadyAdded: true
        };
      }
    );

    this.closeEmitter.emit(selectedCorrespondants);
  }

  removeCorrespondant(index: number) {
    this.finalSelectedCorrespondants.splice(index, 1);
  }
  public async openDetails(correspondant: AnnuaireResultCorrespondant) {
    this.correspondantInfos = correspondant;
    /**
     * TODO Les spécialités récupérées ici ne sont pas les bonnes
     * Elles ont des id de type uuid
     * alors que le correspondant a un idSpecialite de type {code}++{codeSystem}
     */
    if (
      correspondant.idSpecialite &&
      correspondant.idSpecialite !== '' &&
      (!correspondant.specialiteName || correspondant.specialiteName === '')
    ) {
      this.specialiteName =
        this.refSpecialite.find((x) => x.id === correspondant.idSpecialite)
          ?.libelle || '';
    } else {
      this.specialiteName = correspondant.specialiteName;
    }
    if (!correspondant.email2 && correspondant.rpps) {
      const ldapFilter: PractitionerSearchParams = {
        rpps: correspondant.rpps,
      };
      const ldapKeys = Object.keys(ldapFilter);
      const atLeastOneValidField = ldapKeys.find(
        (k) =>
          ldapFilter[k] !== undefined &&
          ldapFilter[k] !== null &&
          ldapFilter[k] !== ''
      );
      if (atLeastOneValidField) {
        const load = this._modal.openLoading(this._view);
        try {
          const tmp = await this._annuaireProSrv.searchProfessionals(
            ldapFilter,
            -1,
            0,
            true
          );
          if (tmp.result && tmp.result.length > 0) {
            this.correspondantInfos.email2 = '';
            for (const mssAddress of tmp.result) {
              this.correspondantInfos.email2 += mssAddress.msSanteAddress + ',';
            }
          }
        } catch (error) {
          console.error(error);
        } finally {
          this._modal.close(load);
        }
      }
    }
    const modal = this._modal.openInfoCorrespondant(
      this._view,
      this.correspondantInfos
    );
    const sub = modal.instance.closeEmitter.subscribe(async (x) => {
      if (x) {
        const load = this._modal.openLoading(this._view);
        await this.recordCorrespondant(x);
        this._modal.close(load);
      }
      this._modal.close(modal);
      sub.unsubscribe();
    });
  }

  private _mapPractitionerSearchResultToAnnuaireResultCorrespondant(
    result: Practitioner
  ): AnnuaireResultCorrespondant {
    return {
      nom: result.practitionerName,
      prenom: result.firstName,
      codePostal: result.zip,
      ville: result.city,
      email1: result.msSanteAddress,
      specialiteName: result.profession,
    };
  }

  private _getSpecialityLabelFromId(id: string): string {
    let rtd = '';
    if (id && id !== '') {
      const tmp = this.refSpecialite.find((s) => s.id === id);
      rtd = tmp ? tmp.libelle : '';
    }
    return rtd;
  }

  private _getProfessionLabelFromId(id: string): string {
    let rtd = '';
    if (id && id !== '') {
      const tmp = this.refSpecialite.find((s) => s.id === id);
      rtd = tmp ? tmp.libelle : '';
    }
    return rtd;
  }

  public cleanInfosCorrespondant() {
    this.correspondantInfos = undefined;
  }

  public async recordCorrespondant(correspondant: AnnuaireResultCorrespondant) {
    const loader = this._modal.openLoading(this._view);
    try {
      const dbCorres = [correspondant];
      correspondant.isAdresseMssFromAnn = true;
      correspondant.isCategorieFromAnn = true;
      correspondant.isFromAnnuaire = true;
      correspondant.isNomFromAnn = true;
      correspondant.isPrenomFromAnn = true;
      correspondant.isProfessionFromAnn = true;
      correspondant.isRppsFromAnn = true;
      correspondant.isSpecialiteFromAnn = true;
      await this._correspondant.create(dbCorres);
      this._snack.openSnackBar(
        'Le correspondant a été ajouté à votre annuaire.'
      );
    } catch (e) {
      console.error(e);
      this._snack.openSnackBarError(e.message);
    } finally {
      this._modal.close(loader);
    }
  }

  public redirectToSiteAnnuaire() {
    window.open('https://annuaire.sante.fr');
  }
  public redirectToSiteAnnuaireApi() {
    window.open('https://apicrypt.org/annuaire');
  }

  public async doSearchRecipients(forceSearch = true, page = 1): Promise<void> {
    const practitionerName = this.formGroup.get('exerciceName')?.value?.trim() || '';
    const firstName = this.formGroup.get('firstName')?.value?.trim() || '';
    const profession = this.formGroup.get('profession')?.value?.trim() || '';
    const speciality = this.formGroup.get('speciality')?.value?.trim() || '';
    const rpps = this.formGroup.get('rpps')?.value?.trim() || '';
    const structureOrAddress = this.formGroup.get('structureOrAddress')?.value?.trim() || '';
    const emailMSS = this.formGroup.get('email')?.value?.trim() || '';
    const zip = this.formGroup.get('zip')?.value?.trim() || '';
    const city = this.formGroup.get('city')?.value?.trim() || '';

    if (!this.isSearching) {
      try {
        this.isSearching = true;
        this.result = await this._mssSrv.getService().findMSSRecipient(
          {
            city,
            zip,
            structureOrAddress,
            emailMSS,
            firstName,
            practitionerName,
            profession,
            speciality,
            rpps
          },
          40, //limite par page
          page - 1,
          forceSearch
        );
        this._initTableDisplay(this.result);
      } catch (e) {
        console.error(e);
        this._modal.openAlert(this._view, 'Erreur', e?.error?.message || e.message);
      } finally {
        this.isSearching = false;
      }
    }
  }

  private _initTableDisplay(practictioners: PractitionerSearchResult): void {
    this.correspondantsFiltred = [];
    this.correspondantsFiltred.push(
      ...practictioners.result.map((x) => {
        const result: AnnuaireResultCorrespondant = {
          rpps: x.rpps,
          adresse1: x.address,
          codePostal: x.zip,
          ville: x.city,
          email2: x.msSanteAddress,
          nom: x.practitionerName,
          prenom: x.firstName,
          idSpecialite: `${x.codeSpecialite}++${SPECIALITE_OID}`,
          specialiteName: x.codeSpecialite
            ? this._getSpecialityLabelFromId(
                `${x.codeSpecialite}++${SPECIALITE_OID}`
              )
            : undefined,
          idProfession: `${x.codeProfession}++${PROFESSION_OID}`,
          professionName: x.codeProfession
            ? this._getProfessionLabelFromId(
                `${x.codeProfession}++${PROFESSION_OID}`
              )
            : undefined,
          isFromAnnuaire: true,
        };
        return result;
      })
    );
    this.trierCorrespondants();
  }

  private _initTableDisplayApi(
    practictioners: PractitionerSearchResultApi
  ): void {
    this.correspondantsFiltred = [];
    this.correspondantsFiltred.push(
      ...practictioners.result.map((x) => {
        const mail = x.mail
          ? x.mail
              .split(',')
              .map((m) => m.trim())
              .filter((m) => m.includes('apicrypt'))
              .join(',')
          : undefined;

        const result: AnnuaireResultCorrespondant = {
          rpps: x.rpps,
          codePostal: x.zip,
          ville: x.city,
          adresseApiCrypt: mail,
          nom: x.practitionerName,
          prenom: x.firstName,
          professionName: x.profession,
          infos: x.specialite,
        };
        return result;
      })
    );
    this.trierCorrespondants();
  }

  private trierCorrespondants() {
    this.correspondantsFiltred.sort((a, b) => {
      const nomA = (a.nom || '').toLowerCase();
      const nomB = (b.nom || '').toLowerCase();
      const prenomA = (a.prenom || '').toLowerCase();
      const prenomB = (b.prenom || '').toLowerCase();

      const cmpNom = nomA.localeCompare(nomB);
      return cmpNom !== 0 ? cmpNom : prenomA.localeCompare(prenomB);
    });
  }

  public onTabChanged(index: number): void {
    this.selectedTabIndex = index;
    this.correspondantsFiltred = null;
    this.result = {
      troncated: false,
      result: [],
      page: 1,
      perpage: 20,
      total: 0,
    };
    this.isSearching = false;
  }

  public async doSearchRecipientsApi(
    forceSearch = true,
    page = 1
  ): Promise<void> {
    const practitionerName =
      this.formGroup.get('exerciceName')?.value?.trim() || '';
    const firstName = this.formGroup.get('firstName')?.value?.trim() || '';
    const specialite =
      this.formGroup.get('professionSpeciality')?.value?.trim() || '';
    const postalCode = this.formGroup.get('zip')?.value?.trim() || '';
    const ville = this.formGroup.get('city')?.value?.trim() || '';
    const departement = '';

    if (!this.isSearching) {
      try {
        this.isSearching = true;
        this.resultApi = await this._mssSrv.getService().findMSSRecipientApi(
          {
            ville,
            firstName,
            practitionerName,
            specialite,
            postalCode,
            departement,
          },
          40, //limite par page
          page - 1,
          forceSearch
        );
        this._initTableDisplayApi(this.resultApi);
      } catch (e) {
        console.error(e);
        this._modal.openAlert(this._view, 'Erreur', e?.error?.message || e.message);
      } finally {
        this.isSearching = false;
      }
    }
  }

  public resetSearchForm(): void {
    this.formGroup.reset();
    this.searchCorrespondantForm.reset();
  }

  get isformGroupDirty(): boolean {
    return (
      this.formGroup &&
      Object.values(this.formGroup.controls).some((control) => control.dirty)
    );
  }
  get isSearchFormDirty(): boolean {
    return (
      this.searchCorrespondantForm &&
      Object.values(this.searchCorrespondantForm.controls).some(
        (control) => control.dirty
      )
    );
  }

  async initCorrespPatient() {
    this.dataSource = new MatTableDataSource<Correspondant>([]);
    this.dataSourceCabinet = new MatTableDataSource<Correspondant>([]);

    //On stocke les ids des correspondants du patient pour aller requêter leurs infos dans le back.
    let ids: string[] = [];
    const repertoirePatient = await this._patient.findOnePatientRepertoire(
      this.idPatient
    );
    this.untouchedCorrespondantsPatient = repertoirePatient.correspondants;

    for (let correspondant of this.untouchedCorrespondantsPatient) {
      ids.push(correspondant.idCorrespondant);
    }
    if(ids.length > 0){
      this.correspondantsPatient = await this._correspondant.find(
      {
        perpage: 0,
        currentPage: 1,
        sortBy: 'nom',
        sortOrder: SortEnum.ASC,
      },
      ids
    );
    }else{
      this.correspondantsPatient = [];
    }
    

    const data = [];
    for (let cor of this.correspondantsPatient) {
      Object.defineProperty(cor, 'nom complet', {
        value: cor.nom + ' ' + cor.prenom,
      });
      data.push(cor);
    }
    this.untouchedContacts = repertoirePatient.repertoires;
    for (let int of this.untouchedContacts) {
      Object.defineProperty(int, 'nom complet', {
        value: int.nom + ' ' + int.prenom,
      });
      data.push(int);
    }
    
      const filtered = data
    .map(cor => {
      this.formatEmails(cor, this.isApicryptAccount);
      return cor;
    })
    .filter(cor => cor.emails && cor.emails.length > 0);

//On trie par ordre alphabétique les correspondants ici, car ils viennent de 2 endpoints différents donc on ne peut pas les trier dans le back.
    filtered.sort((a, b) => {
      const nomA = (a['nom complet'] || '').toLowerCase();
      const nomB = (b['nom complet'] || '').toLowerCase();
      if (nomA < nomB) return -1;
      if (nomA > nomB) return 1;
      return 0;
    });
    
    this.dataSource.data = filtered;
  }
/**
 * les adresses mss et apicrypt sont mélangées entre email2 et adresseApicrypt, il faut donc trier dans l'ensemble des adresses.
 * dans le cas d'un compte mss on ne doit afficher que les adresses mss et @interop-mssante.apicrypt.org
 * dans le cas d'apicrypt on affiche tout
 */
private formatEmails(correspondant: any, isApicryptAccount: boolean) {
  const emails2 = (correspondant.email2 || '')
    .split(',')
    .map((e) => e.trim())
    .filter((e) => e.length > 0)
    .map((e) => ({
      value: e.endsWith('*') ? e.slice(0, -1).trim() : e,
      favorite: e.endsWith('*'),
      type: 'email2' as const,
    }));

  const apicryptEmails = (correspondant.adresseApiCrypt || '')
    .split(',')
    .map((e) => e.trim())
    .filter((e) => e.length > 0)
    .map((e) => ({
      value: e,
      favorite: false,
      type: 'adresseApiCrypt' as const,
    }));

  let allEmails = [...emails2, ...apicryptEmails];

  // Filtrage MSS / Apicrypt
  if (!isApicryptAccount) {
    allEmails = allEmails.filter((mail) => {
      const value = (mail.value || '').toLowerCase();
      if (value.includes('apicrypt')) {
        return value.includes('@interop-mssante.apicrypt.org');
      }
      return true;
    });
  }

  // Mettre le favori MSS en premier
  const favIndex = allEmails.findIndex((e) => e.favorite);
  if (favIndex !== -1) {
    const [fav] = allEmails.splice(favIndex, 1);
    allEmails.unshift(fav);
  }

  correspondant.emails = allEmails;
}


  private _loading: ComponentRef<LoadingModalFragment> | undefined = undefined;

  private async _displayLoading(doDisplay: boolean): Promise<void> {
    if (doDisplay && !this._loading) {
      this._loading = this._modal.openLoading(this._view);
    } else if (!doDisplay && this._loading) {
      this._loading.destroy();
      this._loading = undefined;
    }
  }

  selectCorrespondant(
    correspondant: CorrespondantExtended | Correspondant,
    adresseType?: 'adresseApiCrypt' | 'email2',
    emailValue?: string
  ) {
    if (adresseType && emailValue) {
      const normalized = emailValue.trim().toLowerCase();

      if (adresseType === 'email2') {
        const exists = this.finalSelectedCorrespondants.some(
          (c) =>
            c.isMssSelected &&
            (c.email2 || '').trim().toLowerCase() === normalized
        );
        if (exists) {
          this._snack.openSnackBarError(
            'Ce correspondant est déjà sélectionné.'
          );
          return;
        }
        this.finalSelectedCorrespondants.push({
          ...correspondant,
          email2: emailValue,
          isMssSelected: true,
        });
        return;
      }

      if (adresseType === 'adresseApiCrypt') {
        const exists = this.finalSelectedCorrespondants.some(
          (c) =>
            c.isApicryptSelected &&
            (c.adresseApiCrypt || '').trim().toLowerCase() === normalized
        );
        if (exists) {
          this._snack.openSnackBarError(
            'Ce correspondant est déjà sélectionné.'
          );
          return;
        }
        this.finalSelectedCorrespondants.push({
          ...correspondant,
          adresseApiCrypt: emailValue,
          isApicryptSelected: true,
        });
        return;
      }
    }

    const first = (correspondant as any).emails?.[0];
    if (first) {
      this.selectCorrespondant(correspondant, first.type, first.value);
      return;
    }

    this._snack.openSnackBarError(
      'Aucune adresse sélectionnable pour ce correspondant.'
    );
  }

  public async filterCorrespondants(needle: string): Promise<void> {
    this.searchDone = true;
    const _normalizeStr = (str: string): string => {
      return this._strUtilsSrv.removeAccents(str).toLowerCase();
    };

    try {
      await this._displayLoading(true);
      let data;
      if (needle && needle.length >= 2) {
        // on lance la recherche à partir de 2 lettres
        data = await this._correspondant.find(
          {
            perpage: 0,
            currentPage: 1,
            sortBy: 'nom',
            sortOrder: SortEnum.ASC,
          },
          null,
          needle
        );
        data = data.filter(
          (cor) =>
            _normalizeStr(cor.nom).includes(_normalizeStr(needle)) ||
            _normalizeStr(cor.prenom).includes(_normalizeStr(needle))
        );
        const filtered = data
          .map(cor => {
            this.formatEmails(cor, this.isApicryptAccount);
            return cor;
          })
          .filter(cor => cor.emails && cor.emails.length > 0);

        for (let co of filtered) {
          Object.defineProperty(co, 'nom complet', {
            value: co.nom + ' ' + co.prenom,
          });
        }
        
        this.dataSourceCabinet.data = filtered;
      } else {
        this.searchDone = false;
        data = [];
        this.dataSourceCabinet.data = [];
      }
    } catch (e) {
      console.error(e);
    } finally {
      await this._displayLoading(false);
    }
  }

  validateCorrespondant() {
    this.correspondantsSelected.emit(this.selectBodyTablePatient.objects);
    this.closeEmitter.emit();
  }
}
